export default __webpack_public_path__ + "static/media/Empório-dos-cosmeticos.4ed8edda.jpg";